@for (paramData of textParamDatas; track paramData) {
  <display-param-text-data
  [paramData]="paramData"></display-param-text-data>
}

@for (paramData of treeParamDatas; track paramData.data; let i = $index) {
  <div>
    @if (treeViewDatas[i]?.serverData != null) {
      <display-param-treeview-data
        [paramData]="paramData"
      [treeViewData]="treeViewDatas[i]"></display-param-treeview-data>
    }
  </div>
}

<display-param-grouped-treeview-data paramTitle="Vård av"
  [paramDatas]="vardAvParamDatas"
[treeViewDatas]="vardAvViewDatas"></display-param-grouped-treeview-data>

<display-param-grouped-treeview-data paramTitle="Diagnosgrupp"
  [paramDatas]="diagnosParamDatas"
[treeViewDatas]="diagnosViewDatas"></display-param-grouped-treeview-data>

<display-param-grouped-treeview-data paramTitle="Extern konsult"
  [paramDatas]="externKonsultParamDatas"
[treeViewDatas]="externKonsultViewDatas"></display-param-grouped-treeview-data>
